import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table }                    from "semantic-ui-react";
import GetFacilities                from "../../../application/usecase/facility/GetFacilities";
import GetReservations              from "../../../application/usecase/reservation/GetReservations";
import GetReservationSetting        from "../../../application/usecase/reservation/GetReservationSetting";
import Facilities                   from "../../../domain/facility/Facilities";
import Time                         from "../../../domain/fundamentals/date/Time";
import Reservation                  from "../../../domain/reservation/Reservation";
import Reservations                 from "../../../domain/reservation/Reservations";
import ReservationSetting           from "../../../domain/reservation/ReservationSetting";
import { ResKaState }               from "../../../index";
import ReservationButton            from "./ReservationButton";
import ReservationDateSelector      from "./ReservationDateSelector";

const ReservationTimeTable: FC = () => {
  const reservation: Reservation = useSelector((state: ResKaState) => state.reservation);
  const reservations: Reservations = useSelector((state: ResKaState) => state.reservations);
  const facilities: Facilities = useSelector((state: ResKaState) => state.facilities);
  const setting: ReservationSetting = useSelector((state: ResKaState) => state.reservationSetting);
  const getReservationSetting: GetReservationSetting = new GetReservationSetting(useDispatch());
  const getFacilities: GetFacilities = new GetFacilities(useDispatch());
  const getReservations: GetReservations = new GetReservations(useDispatch());


  useEffect(() => {
    getReservationSetting.execute();
    getFacilities.execute();
    getReservations.execute(reservation.detail.date);
  }, []);

  return (
    <>
      <Table
        celled
        definition
        striped
      >
        <Table.Row>
          <Table.HeaderCell width={ 1 }>
            <div style={ {padding: "1rem"} }>
              <ReservationDateSelector/>
            </div>
          </Table.HeaderCell>
          {
            facilities.toList().map(facility => (
              <Table.HeaderCell textAlign="center" width={ 3 }>{ facility.name.value }</Table.HeaderCell>
            ))
          }
        </Table.Row>
        <Table.Body>
          {
            reservations.timelines.toList().map(timeline => (
              <Table.Row>
                <Table.Cell collapsing>{ timeline.value }</Table.Cell>
                {
                  facilities.toList().map(facility => (
                    <>
                      <Table.Cell textAlign="center" width={ 3 }>
                        <ReservationButton
                          reservations={ reservations.filterByFacility(facility.id).filterByTime(Time.ofText(timeline.value)) }
                          facility={ facility }
                          from={ Time.ofText(timeline.value) }
                          to={ Time.ofText(timeline.value).addMinute(setting.timeType.toNumber()) }
                        />
                      </Table.Cell>
                    </>
                  ))
                }
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>
    </>
  );
};

export default ReservationTimeTable;
